import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Paper,
  styled,
  Divider,
} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const StatsCard = styled(Card)(({ theme }) => ({
  height: '100%',
  textAlign: 'center',
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-5px)',
  },
}));

const TeamMemberCard = styled(Card)(({ theme }) => ({
  height: '100%',
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[10],
  },
}));

const MemberImage = styled('img')({
  width: '100%',
  height: 240,
  objectFit: 'cover',
});

const teamMembers = [
  { 
    name: 'Abhijeet Singh',
    role: 'Director',
    image: '/images/team/Abhijeet-Singh.jpg',
    category: 'leadership'
  },

    { 
    name: 'Arvind Singh',
    role: 'Director',
    image: '/images/team/Arvind-Singh.jpg',
    category: 'leadership'
  },

  { 
    name: 'Ashutosh Pandey',
    role: 'Manager',
    image: '/images/team/Ashustosh-Pandey.jpg',
    category: 'leadership'
  },
  { 
    name: 'Prasad Naik',
    role: 'Disbursement Head',
    image: '/images/team/Prasad-Naiks.jpg',
    category: 'leadership'
  },
  { 
    name: 'Vinay Singh',
    role: 'Sanction Head',
    image: '/images/team/vinay-singh.jpg',
    category: 'leadership'
  },
  { 
    name: 'Yatin Gharat',
    role: 'CRM Head',
    image: '/images/team/Yatin-Gharat.jpg',
    category: 'leadership'
  },
  { 
    name: 'Krutika Naik',
    role: 'HR Head',
    image: '/images/team/Krutika-Naik.jpg',
    category: 'operations'
  },

  { 
    name: 'Yash Patil',
    role: 'Data Entry Analyst',
    image: '/images/team/Yash-Patil.jpg',
    category: 'operations'
  },

  
  { 
    name: 'Vaishnavi Patil',
    role: 'Backend Executive',
    image: '/images/team/Vaishnavi-Patil.jpg',
    category: 'operations'
  },
  
  { 
    name: 'Akash Shedge',
    role: 'Team Leader',
    image: '/images/team/Akash-Shedge.jpg',
    category: 'team-leaders'
  },

  { 
    name: 'Aniket Malkar',
    role: 'Team Leader',
    image: '/images/team/Aniket-Malkar.jpg',
    category: 'team-leaders'
  },

  { 
    name: 'Devendra Verma',
    role: 'Sale Executive',
    image: '/images/team/Devendra-Vermas.jpg',
    category: 'sales'
  },

    { 
    name: 'Pratik Margaj',
    role: 'Sale Executive',
    image: '/images/team/Pratik-Margaj.jpg',
    category: 'sales'
  },

  { 
    name: 'Aakash Chaurasia',
    role: 'Sale Executive',
    image: '/images/team/Aakash-Chaurasia.jpg',
    category: 'sales'
  },
  { 
    name: 'Hetal Shah',
    role: 'Sale Executive',
    image: '/images/team/Hetal-Shah.jpg',
    category: 'sales'
  },

  { 
    name: 'Nikita Nai',
    role: 'Sale Executive',
    image: '/images/team/Nikita-Nai.jpg',
    category: 'sales'
  },
 
  { 
    name: 'Vilas Trimbakar',
    role: 'Office Assistant',
    image: '/images/team/Vilas-Trimbakar.jpg',
    category: 'operations'
  },
];

const categories = [
  { id: 'leadership', title: 'Leadership Team' },
  { id: 'team-leaders', title: 'Team Leaders' },
  { id: 'operations', title: 'Operations Team' },
  { id: 'sales', title: 'Sales Team' },
];

function About() {
  return (
    <Box>
      <Paper
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          py: 6,
          mb: 6,
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h3" gutterBottom>
            About Us
          </Typography>
          <Typography variant="h6" sx={{ maxWidth: 800, opacity: 0.9 }}>
            Your Trusted Financial Partner
          </Typography>
        </Container>
      </Paper>

      <Container maxWidth="lg">
        {/* Company Description */}
        <Box sx={{ mb: 8 }}>
          <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
            Aaradhya Finance and Realty Pvt Ltd is one of the leading companies in the Finance and Realty Sector. 
            Established in Year 2010, the company was founded by Abhijeet Singh. We provide loan facilities from 
            various Banking partners to Customers as well as helping people for getting their dream home.
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
            We have partnered with LIC Housing Finance, HDFC Housing, ICICI Housing Finance, PNB Housing Finance, 
            Aadhar Housing Finance Ltd, GIC Housing Finance Ltd and many others. Our Company Branch Offices are 
            located in Virar & Andheri.
          </Typography>
        </Box>

        {/* Stats Section */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          <Grid item xs={12} md={6}>
            <StatsCard>
              <PeopleIcon sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
              <Typography variant="h3" color="primary.main" gutterBottom>
                4,000+
              </Typography>
              <Typography variant="h6">
                Satisfied Customers
              </Typography>
            </StatsCard>
          </Grid>
          <Grid item xs={12} md={6}>
            <StatsCard>
              <AccessTimeIcon sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
              <Typography variant="h3" color="primary.main" gutterBottom>
                15
              </Typography>
              <Typography variant="h6">
                Years of Experience
              </Typography>
            </StatsCard>
          </Grid>
        </Grid>

        {/* Team Section */}
        <Box sx={{ mb: 8 }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4, textAlign: 'center' }}>
            Our Team
          </Typography>
          
          {categories.map((category) => {
            const categoryMembers = teamMembers.filter(member => member.category === category.id);
            if (categoryMembers.length === 0) return null;
            
            return (
              <Box key={category.id} sx={{ mb: 6 }}>
                <Typography variant="h5" gutterBottom sx={{ mb: 3, color: 'primary.main' }}>
                  {category.title}
                </Typography>
                <Grid container spacing={3}>
                  {categoryMembers.map((member, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <TeamMemberCard>
                        <MemberImage
                          src={member.image}
                          alt={member.name}
                          onError={(e) => {
                            e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(member.name)}&background=1a3c61&color=fff&size=240`;
                          }}
                        />
                        <CardContent sx={{ textAlign: 'center' }}>
                          <Typography variant="h6" gutterBottom>
                            {member.name}
                          </Typography>
                          <Typography variant="subtitle1" color="text.secondary">
                            {member.role}
                          </Typography>
                        </CardContent>
                      </TeamMemberCard>
                    </Grid>
                  ))}
                </Grid>
                {category.id !== categories[categories.length - 1].id && (
                  <Divider sx={{ mt: 6 }} />
                )}
              </Box>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
}

export default About; 